<template>
  <div>
    <PhysicalActivitiesAwayComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import PhysicalActivitiesAwayComp from "@/components/desktop/Activities/PhysicalActivitiesAwayComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'PhysicalActivitiesAway',
    props: ['mobile'],
    components: {
      PhysicalActivitiesAwayComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
